"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _gsap = require("gsap");

var _lottieWeb = _interopRequireDefault(require("lottie-web"));

var _LottieAnimationAPI2 = _interopRequireDefault(require("./LottieAnimationAPI"));

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// function toDataURL (url) {
//     return new Promise((resolve) => {
//         const xhr = new XMLHttpRequest();
//         xhr.onload = function () {
//             const reader = new FileReader();
//             reader.onloadend = function () {
//                 window.console.log('LOAD END PHOTO:', url);
//                 resolve(reader.result);
//             };
//             reader.readAsDataURL(xhr.response);
//         };
//         xhr.open('GET', url);
//         xhr.responseType = 'blob';
//         window.console.log('LOADING PHOTO:', url);
//         xhr.send();
//     });
// }
function getAnimationSliderValue(animationId) {
  var photoAnimation = (0, _utils.GetPhotoAnimation)(animationId);
  return photoAnimation ? photoAnimation.sliderValue : 1;
}

function getRatioByName(ratio) {
  switch (ratio) {
    case '1:1':
      return 'square';

    case '9:16':
      return 'vertical';

    default:
      return 'widescreen';
  }
}

function getRatioSize(ratio, attr) {
  var w;
  var h;

  switch (ratio) {
    case '1:1':
      w = 720;
      h = 720;
      break;

    case '9:16':
      w = 720;
      h = 1280;
      break;

    default:
      w = 1280;
      h = 720;
  }

  if (attr === 'width') {
    return w;
  }

  return h;
}
/**
     * getFullAnimationId() get animation id to pick the relevent file from animation object paremeters
     * @ animation object
     */


function getFullAnimationId(_ref) {
  var start = _ref.start,
      crop = _ref.crop;
  var id;

  switch (start.transition) {
    case 'cut':
      id = 'Photo00';
      break;

    default:
      id = start.transition;
  }

  var animationId = "".concat(id, "_").concat(getRatioByName(crop.aspectRatio));
  return animationId;
}
/**
     * getCropImage() get crop image url from crop object
     * @ animation object
     */


function getCropImage(_ref2) {
  var photo = _ref2.photo,
      crop = _ref2.crop,
      cdn = _ref2.cdn,
      filter = _ref2.filter;
  var targetW = getRatioSize(crop.aspectRatio, 'width');
  var targetH = getRatioSize(crop.aspectRatio, 'height');
  return (0, _utils.CropImage)(photo.url, crop, targetW, targetH, cdn, filter);
}
/**
     * getBlurImage() get crop image url from crop object
     * @ animation object
     */


function getBlurImage(_ref3) {
  var photo = _ref3.photo,
      crop = _ref3.crop,
      cdn = _ref3.cdn;
  var targetW = getRatioSize(crop.aspectRatio, 'width');
  var targetH = getRatioSize(crop.aspectRatio, 'height');
  return (0, _utils.BlurImage)(photo.url, targetW, targetH, cdn);
}
/**
     * setPhotoAnimation() set the animation slider value from animation id
     * @ animation data (lottie)
     * @ animation id
     */


function setPhotoAnimation(animation, animationId) {
  // eslint-disable-next-line max-len
  var pattern = new RegExp(/"ef":\[{"ty":5,"nm":"animationControl","np":3,"mn":"ADBE Slider Control","ix":1,"en":1,"ef":\[{"ty":0,"nm":"Slider","mn":"ADBE Slider Control-0001","ix":1,"v":{"a":0,"k":[0-9]+,"ix":1}}\]}\]/); // eslint-disable-next-line max-len

  var to = "\"ef\":[{\"ty\":5,\"nm\":\"animationControl\",\"np\":3,\"mn\":\"ADBE Slider Control\",\"ix\":1,\"en\":1,\"ef\":[{\"ty\":0,\"nm\":\"Slider\",\"mn\":\"ADBE Slider Control-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":".concat(getAnimationSliderValue(animationId), ",\"ix\":1}}]}]");
  return animation.replace(pattern, to);
}

function onDOMLoaded() {
  if (this.imagesLoaded) {
    this.animation.trigger('ready');
    this.ready = true;
    this.DOMLoaded = true;
    this.animation.removeEventListener('DOMLoaded', this.BindOnDOMLoaded);

    if (typeof this.afterReady === 'function') {
      this.afterReady();
    }
  }
}

function onLoadedImages() {
  this.imagesLoaded = true;
  this.animation.removeEventListener('loaded_images', this.BindOnLoadedImages);
} // photo base class


var LottieAnimationBase = /*#__PURE__*/function (_LottieAnimationAPI) {
  _inherits(LottieAnimationBase, _LottieAnimationAPI);

  var _super = _createSuper(LottieAnimationBase);

  function LottieAnimationBase(animationName, animationObj, config) {
    var _this;

    _classCallCheck(this, LottieAnimationBase);

    _this = _super.call(this);
    _this.config = config;
    _this.animationId = getFullAnimationId(animationObj);
    _this.images = animationObj.images;
    return _this;
  }
  /**
   * _loadAnimation() load lottie animation (private function)
   * load the lottie animation update animation data with size and fonts before load
   * set animation position and size if animation include style object
   */


  _createClass(LottieAnimationBase, [{
    key: "_loadAnimation",
    value: function _loadAnimation(data, container) {
      this.container = container;
      var style = {
        width: '100%',
        height: '100%'
      };
      this.innerContainer = document.createElement('div');

      _gsap.TweenMax.set(this.innerContainer, style);

      this.container.appendChild(this.innerContainer);
      var params = {
        container: this.innerContainer,
        renderer: 'canvas',
        loop: false,
        autoplay: false,
        animationData: data
      };

      if (this.config.rendererSettings) {
        params.rendererSettings = this.config.rendererSettings;
      }

      this.animation = _lottieWeb.default.loadAnimation(params); // wait for image to be load than trigger custom ready event

      this.BindOnLoadedImages = onLoadedImages.bind(this);
      this.animation.addEventListener('loaded_images', this.BindOnLoadedImages);
      this.BindOnDOMLoaded = onDOMLoaded.bind(this);
      this.animation.addEventListener('DOMLoaded', this.BindOnDOMLoaded);
    }
  }, {
    key: "_setPhoto",
    value: function _setPhoto(animation, animationObj) {
      var backgroundUrl = getCropImage(animationObj);
      var blured = getBlurImage(animationObj);
      animation = setPhotoAnimation(animation, animationObj.animation.id);
      animation = animation.replace(/images\//g, ' ').replace(/img_0.png/g, backgroundUrl).replace(/img_1.png/g, blured);
      return animation;
    } // download images and change url to base64 need for canvas snap server side

  }, {
    key: "prepareAssets",
    value: function prepareAssets() {
      var _this2 = this;

      window.console.log('PHOTO - prepareAssets');
      window.console.log('Cached photos', Object.keys(this.images).toString());
      return Promise.all(this.json.assets.map( /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(asset) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (asset.id.indexOf('image') !== -1) {
                    window.console.log('DATA READY PHOTO:', asset.p);
                    asset.p = _this2.images[asset.p];

                    if (asset.p) {
                      window.console.log('HASH: ', strHash(asset.p));
                    } // return toDataURL(asset.p).then((b64) => { asset.p = b64 })

                  }

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref4.apply(this, arguments);
        };
      }()));
    }
  }]);

  return LottieAnimationBase;
}(_LottieAnimationAPI2.default);

exports.default = LottieAnimationBase;

function strHash(str) {
  var hash = 0;
  var i;
  var chr;

  if (str.length === 0) {
    return hash;
  }

  for (i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i); // eslint-disable-next-line no-bitwise

    hash = (hash << 5) - hash + chr; // eslint-disable-next-line no-bitwise

    hash |= 0; // Convert to 32bit integer
  }

  return hash;
}